import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProgramacionService {

  private apiUrl = `${environment.apiUrl}/programacion`;

  constructor(private http: HttpClient) { }

  getProgramacion() {
    return this.http.get<any>(`${this.apiUrl}`);
  }
  createProgramacion(programacion: any) {
    return this.http.post<any>(`${this.apiUrl}`, programacion);
  }
  deleteProgramacion(id: number) {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
  getProgramacionById(id: number) {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }
  updateProgramacion(id: number, programacion: any) {
    return this.http.put<any>(`${this.apiUrl}/${id}`, programacion);
  }
}
